import { useFetch } from "hooks/api";
import Accordion from "components/core/basic/Accordion";
import UsersTable from "components/custom/onboarding/UsersTable";
import { useAppSelector } from "redux/hooks";
import Card from "components/core/basic/Card";

const UserActivityTable = () => {
  const user = useAppSelector((state) => state.user);

  const { data: userData, isLoading: isUserDataLoading } = useFetch(
    ["orgUsers"],
    "/api/org_users/",
    { page_size: 5000 },
    {
      select: (d) => d.data,
      default: [],
      enabled: user.is_staff,
      staleTime: 5 * 60 * 1000,
    },
  );

  return (
    <Accordion title={"User Activity"}>
      <Card>
        <UsersTable
          tableData={userData}
          columnsToRender={["username", "email", "last_login", "is_staff"]}
          isLoading={isUserDataLoading}
          isSelectable={false}
          defaultSorted={[{ id: "last_login", desc: true }]}
        />
      </Card>
    </Accordion>
  );
};

export default UserActivityTable;
